// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 362) return "static/css/362.5581cf550794f2defced.lib.css";
	if (chunkId === 697) return "static/css/697.2e8668dcc69408c23d59.css";
	// return url for filenames based on template
	return undefined;
};